import TenderSettingsForm from './TenderSettingsForm';

export default TenderSettingsForm;
